// Same-origin /api (Kubernetes ingress routes it to the backend). Falls back to
// the env var only when its origin matches the page (defensive against stale builds).
const envUrl = process.env.REACT_APP_BACKEND_URL || "";
let API = "/api";
try {
  if (envUrl && new URL(envUrl).origin === window.location.origin) API = `${envUrl}/api`;
} catch { /* keep relative */ }

export const getToken = () => localStorage.getItem("obff_token");
export const setToken = (t) => {
  if (t) localStorage.setItem("obff_token", t);
  else localStorage.removeItem("obff_token");
};

export async function api(path, opts = {}) {
  const headers = { "Content-Type": "application/json", ...(opts.headers || {}) };
  const t = getToken();
  if (t) headers.Authorization = `Bearer ${t}`;
  const res = await fetch(`${API}${path}`, { ...opts, headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    if (res.status === 401 && !path.startsWith("/auth")) {
      setToken(null);
      window.location.href = "/optin";
    }
    throw new Error(data.detail || "Request failed");
  }
  return data;
}
